import nikoletaPicture from '@content/images/ourTeam/nikoleta-headshot.png';
import sheenaPicture from '@content/images/ourTeam/sheena-headshot.png';
import kevinPicture from '@content/images/ourTeam/kevin-headshot.png';
import annaPicture from '@content/images/ourTeam/anna-headshot.jpeg';
import neelamPicture from '@content/images/ourTeam/neelam-headshot.jpg';
import sarathPicture from '@content/images/ourTeam/sarath-headshot.jpg';

const ourTeam = [
    {
        id: 1,
        name: 'Kevin Brundish',
        jobTitle: 'Innovation Network Chair',
        jobDescription: 'CEO, LionVolt',
        link: 'https://www.linkedin.com/in/kevin-brundish-59158221/',
        image: kevinPicture,
    },
    {
        id: 2,
        name: 'Anna Wise',
        jobTitle: 'Innovation Network Deputy Chair',
        jobDescription: 'Head of Strategic Programmes, Nyobolt',
        link: 'https://www.linkedin.com/in/annamwise/',
        image: annaPicture,
    },
    {
        id: 3,
        name: 'Nikoleta Piperidou',
        jobTitle: 'Project Lead',
        jobDescription: 'Energy & Infrastructure, Innovate UK Business Connect',
        link: 'https://ktn-uk.org/people/nikoleta-piperidou/',
        image: nikoletaPicture,
    },
    {
        id: 4,
        name: 'Sheena Hindocha',
        jobTitle: 'Project Co-Lead',
        jobDescription: 'Head of Clean Energy and Built Environment, Innovate UK Business Connect',
        link: 'https://ktn-uk.org/people/sheena-hindocha/',
        image: sheenaPicture,
    },
    {
        id: 5,
        name: 'Neelam Mughal',
        jobTitle: 'Project Team',
        jobDescription: 'Advanced Materials, Innovate UK Business Connect',
        link: 'https://ktn-uk.org/people/neelam-mughal/',
        image: neelamPicture,
    },
    {
        id: 6,
        name: 'Sarath Perera',
        jobTitle: 'Campaigns Lead',
        jobDescription: 'Innovate UK Business Connect',
        link: null,
        image: sarathPicture,
    },
];

export default ourTeam;
